import React from 'react';

import * as styles from './Loader.module.css';

const Loader = ({size}) => <div className={`${styles.spinner} ${size ? styles[size] : ''}`}></div>;

export default Loader;